import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';

export const templateListRoute: RouteConfig = {
  path: '',
  name: 'templateList',
  component: () => import(/* webpackChunkName: "TemplateList" */ '@/views/mainRoute/template/List.vue'),
  meta: {
    breadcrumb: {
      title: 'Wzóry procedury'
    }
  },
  beforeEnter: (to, from, next) => {
    store
      .dispatch('template/list')
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.TEMPLATE_CANNOT_LIST }));
  }
};
